import { useMutation } from "react-query";
import _ from "lodash";
import { getMerchant } from "../../utils/localStorage";
import { getQueryParam, getTemplatePath } from "../../utils/string";
import { toastError } from "../../utils/toast";

const { default: request } = require("../../utils/request");

const GET_SETTLEMENTS = "/merchants/:merchantId/settlements";
const DOWNLOAD_SETTLEMENT = "/merchants/:merchantId/settlements/:id/download";

const getSettlements = async (payload = {}) => {
  const merchant = getMerchant();
  const url = getTemplatePath(GET_SETTLEMENTS, { merchantId: merchant?._id });
  const sanitizedPayload = _.pickBy(payload, _.identity);
  const query = getQueryParam(sanitizedPayload);

  if (!query) {
    return request.get(url);
  }

  return request.get(`${url}?${query}`);
};

const downloadSettlement = async (id) => {
  const merchant = getMerchant();
  const url = getTemplatePath(DOWNLOAD_SETTLEMENT, { merchantId: merchant?._id, id });
  return request.get(url);
};

const getErrorMessage = (error) => {
  if (_.isArray(error?.response?.data?.message)) {
    return _.get(error, "response.data.message[0]");
  }

  return _.get(error, "response.data.message", "Request failed");
};

export const useGetSettlements = () => {
  return useMutation(getSettlements, {
    onError: (error) => {
      toastError({ description: getErrorMessage(error) });
    },
  });
};

export const useDownloadSettlement = () => {
  return useMutation(downloadSettlement, {
    onError: (error) => {
      toastError({ description: getErrorMessage(error) });
    },
  });
};
